import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import picturefill from '@sparta.global.vendors/picturefill';
import benchmarkUtility from '@sparta.sales.utilities/benchmark-utility/dist/es6.js';
import modalUtility from '@sparta.homepage.utilities/modal-utility/dist/es6.js';
import remoteConsole from '@sparta.homepage.utilities/remote-logging-utility/dist/es6.js';
import animationUtility from '@sparta.homepage.utilities/animation-utility/dist/es6.js';
import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { attrFriendly, codeFriendly } from '@sparta.homepage.helpers/homepage-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { secureLink } from '@sparta.global.helpers/secure-link-helper/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';
import { json } from '@sparta.global.helpers/json-helper/dist/es6.js';

const Template$7 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row collapse hide-for-large-up mobile-wrapper hide\">\r\n  <div class=\"column small-11 medium-10 small-centered\">\r\n    <nav role=\"navigation\" aria-label=\"Main menu\">\r\n      <ul\r\n        class=\"main-nav-links\"\r\n        role=\"navigation\"\r\n        data-rowcount=\""
    + container.escapeExpression((lookupProperty(helpers,"getMobileNavRowCount")||(depth0 && lookupProperty(depth0,"getMobileNavRowCount"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mainNav") : stack1),{"name":"getMobileNavRowCount","hash":{},"data":data,"loc":{"start":{"line":9,"column":23},"end":{"line":9,"column":62}}}))
    + "\"\r\n      >\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(lookupProperty(helpers,"resortNavForMobile")||(depth0 && lookupProperty(depth0,"resortNavForMobile"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mainNav") : stack1),{"name":"resortNavForMobile","hash":{},"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":12,"column":50}}}),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":29,"column":17}}})) != null ? stack1 : "")
    + "      </ul>\r\n      <ul class=\"mobile-buttons\" role=\"presentation\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mobileButtons") : stack1),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":8},"end":{"line":41,"column":17}}})) != null ? stack1 : "")
    + "      </ul>\r\n    </nav>\r\n  </div>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":11},"end":{"line":13,"column":59}}})) != null ? stack1 : "")
    + " role=\"presentation\">\r\n          <a id=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Mobile\" href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bmhHost") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":42},"end":{"line":14,"column":91}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"small") : stack1)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":14,"column":91},"end":{"line":14,"column":165}}})) != null ? stack1 : "")
    + "\"\r\n            class=\"show-for-small-only "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"languageInterstitial") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":39},"end":{"line":15,"column":103}}})) != null ? stack1 : "")
    + "\"\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"languageInterstitial") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":16,"column":125}}})) != null ? stack1 : "")
    + "\r\n          >\r\n            <span class=\"icon\" aria-hidden=\"true\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"title\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n          </a>\r\n          <a id=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Tablet\" href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bmhHost") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":42},"end":{"line":21,"column":91}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":21,"column":91},"end":{"line":21,"column":167}}})) != null ? stack1 : "")
    + "\"\r\n            class=\"show-for-medium-only "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"languageInterstitial") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":40},"end":{"line":22,"column":104}}})) != null ? stack1 : "")
    + "\"\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"languageInterstitial") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":12},"end":{"line":23,"column":125}}})) != null ? stack1 : "")
    + "\r\n          >\r\n            <span class=\"icon\" aria-hidden=\"true\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"title\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n          </a>\r\n        </li>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " class=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\"";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"bmhHost")), depth0));
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"small") : stack1), depth0));
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0));
},"11":function(container,depth0,helpers,partials,data) {
    return "spa-ui-layer-link spa-fn";
},"13":function(container,depth0,helpers,partials,data) {
    return "data-options=\"{&quot;interstitialType&quot;:&quot;language-change&quot;}\"";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"medium") : stack1), depth0));
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":14},"end":{"line":33,"column":62}}})) != null ? stack1 : "")
    + " role=\"presentation\">\r\n            <a id=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Mobile\" href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bmhHost") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":44},"end":{"line":34,"column":93}}})) != null ? stack1 : "")
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\"\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"languageInterstitial") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":35,"column":14},"end":{"line":35,"column":160}}})) != null ? stack1 : "")
    + "\r\n            >\r\n              <span class=\"icon\" aria-hidden=\"true\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n              <span class=\"title\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            </a>\r\n          </li>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    return "class=\"spa-ui-layer-link spa-fn\" data-options=\"{&quot;interstitialType&quot;:&quot;language-change&quot;}\"";
},"20":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row show-for-large-up\">\r\n  <div class=\"column small-10 small-centered large-12\">\r\n    <nav role=\"navigation\" aria-label=\"Main menu\">\r\n      <ul class=\"main-nav-links\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mainNav") : stack1),{"name":"each","hash":{},"fn":container.program(21, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":8},"end":{"line":64,"column":17}}})) != null ? stack1 : "")
    + "      </ul>\r\n    </nav>\r\n  </div>\r\n</div>\r\n<div class=\"row collapse full-width-row show-for-large-up\">\r\n  <div class=\"column small-12 menu-content-container\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"mainNav") : stack1),{"name":"each","hash":{},"fn":container.program(24, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":4},"end":{"line":84,"column":13}}})) != null ? stack1 : "")
    + "    <span class=\"ada-hidden menu-end\" tabindex=\"-1\">"
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"menuEndAdaText") : stack1), depth0)) != null ? stack1 : "")
    + "</span>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"customerType") : stack1),"==","consumer",{"name":"compare","hash":{},"fn":container.program(26, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":89,"column":0},"end":{"line":91,"column":12}}})) != null ? stack1 : "")
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"customerType") : stack1),"==","smallbusiness",{"name":"compare","hash":{},"fn":container.program(28, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":92,"column":0},"end":{"line":94,"column":12}}})) != null ? stack1 : "")
    + "\r\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":11},"end":{"line":55,"column":59}}})) != null ? stack1 : "")
    + ">\r\n          <a role=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"role") || (depth0 != null ? lookupProperty(depth0,"role") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"role","hash":{},"data":data,"loc":{"start":{"line":56,"column":19},"end":{"line":56,"column":31}}}) : helper))) != null ? stack1 : "")
    + "\" id=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"bmhHost") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":56},"end":{"line":56,"column":105}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"large") : stack1)) != null ? lookupProperty(stack1,"length") : stack1),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.program(9, data, 0),"data":data,"loc":{"start":{"line":56,"column":105},"end":{"line":56,"column":179}}})) != null ? stack1 : "")
    + "\" aria-controls=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Content\" aria-expanded=\"false\" aria-live=\"polite\">\r\n            <span class=\"icon\" aria-hidden=\"true\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"ada-hidden\">Open&nbsp;</span>\r\n            <span class=\"title\">"
    + ((stack1 = alias2((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <span class=\"ada-hidden\">&nbsp;Menu</span>\r\n            <span class=\"ada-hidden ada-expand-collapse\"></span>\r\n          </a>\r\n        </li>\r\n";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"url") : depth0)) != null ? lookupProperty(stack1,"large") : stack1), depth0));
},"24":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <section id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "Content\" role=\"tabpanel\">\r\n      <div class=\"row\">\r\n        <div class=\"column small-12 menu-close-container\">\r\n          <a role=\"button\" href=\"javascript:void(0);\" class=\"menu-close\" aria-label=\""
    + ((stack1 = alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"closeText") : stack1), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"attrFriendly")||(depth0 && lookupProperty(depth0,"attrFriendly"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"attrFriendly","hash":{},"data":data,"loc":{"start":{"line":75,"column":110},"end":{"line":75,"column":139}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = (lookupProperty(helpers,"attrFriendly")||(depth0 && lookupProperty(depth0,"attrFriendly"))||alias4).call(alias3,((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"menuText") : stack1),{"name":"attrFriendly","hash":{},"data":data,"loc":{"start":{"line":75,"column":140},"end":{"line":75,"column":176}}})) != null ? stack1 : "")
    + "\" id=\"close-"
    + alias2((lookupProperty(helpers,"codeFriendly")||(depth0 && lookupProperty(depth0,"codeFriendly"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"title") : depth0),{"name":"codeFriendly","hash":{},"data":data,"loc":{"start":{"line":75,"column":188},"end":{"line":75,"column":215}}}))
    + "-l1-nav\">\r\n            "
    + ((stack1 = alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"data1") : depths[1])) != null ? lookupProperty(stack1,"closeText") : stack1), depth0)) != null ? stack1 : "")
    + " <span class=\"close-x\" aria-hidden=\"true\">×</span>\r\n          </a>\r\n        </div>\r\n      </div>\r\n      <div class=\"menu-content\">\r\n"
    + ((stack1 = container.invokePartial((lookupProperty(helpers,"templateName")||(depth0 && lookupProperty(depth0,"templateName"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"id") : depth0),(depths[1] != null ? lookupProperty(depths[1],"data2") : depths[1]),{"name":"templateName","hash":{},"data":data,"loc":{"start":{"line":81,"column":12},"end":{"line":81,"column":43}}}),(lookupProperty(helpers,"templateContent")||(depth0 && lookupProperty(depth0,"templateContent"))||alias4).call(alias3,(depth0 != null ? lookupProperty(depth0,"id") : depth0),(depths[1] != null ? lookupProperty(depths[1],"data2") : depths[1]),{"name":"templateContent","hash":{},"data":data,"loc":{"start":{"line":81,"column":44},"end":{"line":81,"column":78}}}),{"data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "      </div>\r\n    </section>\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"defaultOffers\" data-jcr='{ \"navAd1\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd1DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":46},"end":{"line":90,"column":73}}}))
    + ",\"navAd2\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd2DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":84},"end":{"line":90,"column":111}}}))
    + ",\"navAd3\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd3DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":122},"end":{"line":90,"column":149}}}))
    + ",\"navAd4\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd4DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":160},"end":{"line":90,"column":187}}}))
    + ",\"navAd5\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd5DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":198},"end":{"line":90,"column":225}}}))
    + ",\"navAd6\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd6DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":90,"column":236},"end":{"line":90,"column":263}}}))
    + " }'></div>\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div id=\"defaultOffers\" data-jcr='{ \"navAd1\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd1DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":46},"end":{"line":93,"column":73}}}))
    + ",\"navAd2\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd2DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":84},"end":{"line":93,"column":111}}}))
    + ",\"navAd3\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd3DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":122},"end":{"line":93,"column":149}}}))
    + ",\"navAd4\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd4DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":160},"end":{"line":93,"column":187}}}))
    + ",\"navAd5\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd5DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":198},"end":{"line":93,"column":225}}}))
    + ",\"navAd6\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd6DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":236},"end":{"line":93,"column":263}}}))
    + ",\"navAd7\": "
    + alias3((lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"navAd7DefaultOffer") : depth0),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":93,"column":274},"end":{"line":93,"column":301}}}))
    + " }'></div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"viewport") : stack1),"==","mobile",{"name":"compare","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":46,"column":12}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"viewport") : stack1),"==","desktop",{"name":"compare","hash":{},"fn":container.program(20, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":49,"column":0},"end":{"line":96,"column":12}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true,"useDepths":true});
const renderTemplate$7 = function (data, options) {
  return Template$7(data, options);
};

const Template$6 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"offer "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"offerClass") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":18},"end":{"line":2,"column":57}}})) != null ? stack1 : "")
    + "\">\r\n  <div class=\"offer-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":3,"column":30},"end":{"line":3,"column":44}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n  <div class=\"offer-image\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":7,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"picture") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":4},"end":{"line":10,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"offer-description\"><span class=\"chevron-right\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":12,"column":61},"end":{"line":12,"column":78}}}) : helper))) != null ? stack1 : "")
    + "</span></div>\r\n</div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"offerClass") || (depth0 != null ? lookupProperty(depth0,"offerClass") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"offerClass","hash":{},"data":data,"loc":{"start":{"line":2,"column":36},"end":{"line":2,"column":50}}}) : helper)));
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <img src=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":6,"column":16},"end":{"line":6,"column":27}}}) : helper))) != null ? stack1 : "")
    + "\" loading=\"lazy\" alt=\"\" role=\"presentation\" />\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"picture") : depth0),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":9,"column":6},"end":{"line":9,"column":25}}}))
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"blank") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":14,"column":11}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$6 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$6(data, options);
};

const Template$5 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"intro\">\r\n          <h2 class=\"intro-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":7,"column":37},"end":{"line":7,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          <div class=\"intro-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":10,"column":41},"end":{"line":10,"column":58}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n        </div>\r\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li>\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":12},"end":{"line":18,"column":49}}})) != null ? stack1 : "")
    + "\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":19,"column":62}}})) != null ? stack1 : "")
    + "\r\n          </li>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":18,"column":28},"end":{"line":18,"column":42}}}) : helper))) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":19,"column":34},"end":{"line":19,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bottom-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":30,"column":25},"end":{"line":30,"column":39}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-1\">\r\n  <div class=\"column small-9\">\r\n    <div class=\"row collapse\">\r\n      <div class=\"column small-5\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":12,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\"column small-7\">\r\n        <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":10},"end":{"line":21,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"column small-3 offer-container\"></div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":0},"end":{"line":31,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$5 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$5(data, options);
};

const Template$4 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row collapse menu-item\">\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":5,"column":18},"end":{"line":5,"column":75}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":13,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":8},"end":{"line":24,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":26,"column":18},"end":{"line":26,"column":75}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":8},"end":{"line":37,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":39,"column":6},"end":{"line":50,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "three-items";
},"4":function(container,depth0,helpers,partials,data) {
    return "column small-5";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"intro\">\r\n          <h2 class=\"intro-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":8,"column":37},"end":{"line":8,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          <div class=\"intro-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":11,"column":41},"end":{"line":11,"column":58}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n        </div>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul class=\"list-left\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"each","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":12},"end":{"line":22,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":18,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":19,"column":88}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":16},"end":{"line":20,"column":66}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":18,"column":32},"end":{"line":18,"column":46}}}) : helper))) != null ? stack1 : "");
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":19,"column":33},"end":{"line":19,"column":81}}})) != null ? stack1 : "");
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":20,"column":38},"end":{"line":20,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"16":function(container,depth0,helpers,partials,data) {
    return "column small-7";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":12},"end":{"line":35,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":14},"end":{"line":31,"column":51}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":32,"column":14},"end":{"line":32,"column":86}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":14},"end":{"line":33,"column":102}}})) != null ? stack1 : "")
    + "\r\n            </li>\r\n";
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class='"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"compact") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":33,"column":43},"end":{"line":33,"column":72}}})) != null ? stack1 : "")
    + "'>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":33,"column":74},"end":{"line":33,"column":91}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"21":function(container,depth0,helpers,partials,data) {
    return "compact";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"three-items\">\r\n          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"each","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":12},"end":{"line":47,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </div>\r\n";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":44,"column":16},"end":{"line":44,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":16},"end":{"line":45,"column":88}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"with","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":22},"end":{"line":66,"column":13}}})) != null ? stack1 : "");
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n        <div class=\"lower-tile\">\r\n          <div class=\"lower-tile-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":58,"column":43},"end":{"line":58,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"lower-tile-icon\">\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"svg") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":12},"end":{"line":60,"column":41}}})) != null ? stack1 : "")
    + "\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":12},"end":{"line":61,"column":89}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"cta") : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":10},"end":{"line":63,"column":72}}})) != null ? stack1 : "")
    + "\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":10},"end":{"line":64,"column":117}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n    ";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"svg") || (depth0 != null ? lookupProperty(depth0,"svg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"svg","hash":{},"data":data,"loc":{"start":{"line":60,"column":24},"end":{"line":60,"column":33}}}) : helper))) != null ? stack1 : "")
    + " ";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
    + " loading=\"lazy\" alt="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"alt") : stack1), depth0))
    + ">";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"cta") || (depth0 != null ? lookupProperty(depth0,"cta") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cta","hash":{},"data":data,"loc":{"start":{"line":63,"column":50},"end":{"line":63,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":64,"column":56},"end":{"line":64,"column":104}}})) != null ? stack1 : "")
    + "</div>";
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headline-left") : depth0),{"name":"if","hash":{},"fn":container.program(37, data, 0),"inverse":container.program(39, data, 0),"data":data,"loc":{"start":{"line":72,"column":0},"end":{"line":83,"column":7}}})) != null ? stack1 : "");
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row bottom-link\">\r\n  <div class=\"column small-9\">\r\n    <div class=\"row collapse bottom-link--left\">\r\n      <div class=\"column small-4\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline-left") || (depth0 != null ? lookupProperty(depth0,"headline-left") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline-left","hash":{},"data":data,"loc":{"start":{"line":76,"column":34},"end":{"line":76,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n      <div class=\"column small-7 small-offset-1 headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":77,"column":58},"end":{"line":77,"column":72}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"39":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bottom-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":82,"column":25},"end":{"line":82,"column":39}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-3\">\r\n  <div class=\"column small-9\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"menuItems") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":52,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"column small-3\">\r\n    <div class=\"offer-container\"></div>\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":4},"end":{"line":66,"column":20}}})) != null ? stack1 : "")
    + "\r\n\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":71,"column":0},"end":{"line":84,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$4 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$4(data, options);
};

const Template$3 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row collapse menu-item\">\r\n      <div class=\"column small-5\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":13,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\"column small-7\">\r\n        <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":10},"end":{"line":22,"column":19}}})) != null ? stack1 : "")
    + "        </ul>\r\n      </div>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"intro\">\r\n          <h2 class=\"intro-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":8,"column":37},"end":{"line":8,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          <div class=\"intro-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":11,"column":41},"end":{"line":11,"column":58}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n        </div>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <li>\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":12},"end":{"line":19,"column":49}}})) != null ? stack1 : "")
    + "\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":12},"end":{"line":20,"column":62}}})) != null ? stack1 : "")
    + "\r\n          </li>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":19,"column":28},"end":{"line":19,"column":42}}}) : helper))) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":20,"column":34},"end":{"line":20,"column":51}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bottom-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":32,"column":25},"end":{"line":32,"column":39}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-2\">\r\n  <div class=\"column small-9\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"menuItems") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":26,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"column small-3 offer-container\"></div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":31,"column":0},"end":{"line":33,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$3 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$3(data, options);
};

const Template$2 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"intro\">\r\n      <h2 class=\"intro-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":5,"column":33},"end":{"line":5,"column":47}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n      <div class=\"intro-description\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"btnBMH") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":9,"column":8},"end":{"line":11,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"btnBMH") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"bmhHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":52}}})) != null ? stack1 : "")
    + "\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"offer") : depth0),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":4},"end":{"line":29,"column":13}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"offer-container\">\r\n      <div class=\"offer offer-bmh\">\r\n        <div class=\"offer-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":19,"column":36},"end":{"line":19,"column":50}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n        <div class=\"offer-image\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":10},"end":{"line":22,"column":85}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"picture") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":86},"end":{"line":22,"column":129}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n        <div class=\"offer-description\">\r\n          <span class=\"chevron-right\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":25,"column":38},"end":{"line":25,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <img src=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"image") || (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"image","hash":{},"data":data,"loc":{"start":{"line":22,"column":20},"end":{"line":22,"column":31}}}) : helper))) != null ? stack1 : "")
    + "\" loading=\"lazy\" alt=\"\" role=\"presentation\" /> ";
},"8":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression((lookupProperty(helpers,"picture")||(depth0 && lookupProperty(depth0,"picture"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"picture") : depth0),{"name":"picture","hash":{},"data":data,"loc":{"start":{"line":22,"column":102},"end":{"line":22,"column":121}}}))
    + " ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\r\n          <span class=\"bmh-icon "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0))
    + "\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"svg") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n            <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1(((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"bmhHost")), depth0))
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"url") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":37,"column":74},"end":{"line":37,"column":195}}})) != null ? stack1 : "")
    + ">\r\n            <span class=\"title\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0)) != null ? stack1 : "")
    + "</span>\r\n          </a>\r\n        </li>\r\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " class=\"spa-ui-layer-link spa-fn\" data-options='"
    + ((stack1 = (lookupProperty(helpers,"json")||(depth0 && lookupProperty(depth0,"json"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"actionType") : depth0)) != null ? lookupProperty(stack1,"options") : stack1),{"name":"json","hash":{},"data":data,"loc":{"start":{"line":37,"column":153},"end":{"line":37,"column":187}}})) != null ? stack1 : "")
    + "'";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"bottom-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":47,"column":27},"end":{"line":47,"column":41}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-bmh\">\r\n  <div class=\"column small-4\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":14,"column":13}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"offer") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":4},"end":{"line":30,"column":11}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"column small-8 bmh-icon-container\">\r\n    <ul class=\"bmh-icon-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":6},"end":{"line":41,"column":15}}})) != null ? stack1 : "")
    + "    </ul>\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":46,"column":0},"end":{"line":48,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate$2 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$2(data, options);
};

const Template$1 = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row collapse menu-item\">\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":5,"column":18},"end":{"line":5,"column":75}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":22,"column":17}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":33,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(20, data, 0),"data":data,"loc":{"start":{"line":35,"column":18},"end":{"line":35,"column":75}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":8},"end":{"line":46,"column":15}}})) != null ? stack1 : "")
    + "      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":48,"column":6},"end":{"line":59,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "three-items";
},"4":function(container,depth0,helpers,partials,data) {
    return "column small-5";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"intro\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"image") : depth0),{"name":"with","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":10},"end":{"line":16,"column":19}}})) != null ? stack1 : "")
    + "          <h2 class=\"intro-headline\" style=\""
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headlineStyle") || (depth0 != null ? lookupProperty(depth0,"headlineStyle") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headlineStyle","hash":{},"data":data,"loc":{"start":{"line":17,"column":44},"end":{"line":17,"column":63}}}) : helper))) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":17,"column":65},"end":{"line":17,"column":79}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          <div class=\"intro-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"description","hash":{},"data":data,"loc":{"start":{"line":20,"column":41},"end":{"line":20,"column":58}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n        </div>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"href") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":9,"column":12},"end":{"line":15,"column":19}}})) != null ? stack1 : "");
},"8":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <a id=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"linkId") || (depth0 != null ? lookupProperty(depth0,"linkId") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"linkId","hash":{},"data":data,"loc":{"start":{"line":10,"column":21},"end":{"line":10,"column":31}}}) : helper)))
    + "\" href=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"href") || (depth0 != null ? lookupProperty(depth0,"href") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"href","hash":{},"data":data,"loc":{"start":{"line":10,"column":39},"end":{"line":10,"column":47}}}) : helper)))
    + "\">\r\n                <img class=\"intro-image\" loading=\"lazy\" src=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"src") || (depth0 != null ? lookupProperty(depth0,"src") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"src","hash":{},"data":data,"loc":{"start":{"line":11,"column":61},"end":{"line":11,"column":68}}}) : helper)))
    + "\" alt=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"alt") || (depth0 != null ? lookupProperty(depth0,"alt") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"alt","hash":{},"data":data,"loc":{"start":{"line":11,"column":75},"end":{"line":11,"column":82}}}) : helper)))
    + "\" style=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"inlineStyle") || (depth0 != null ? lookupProperty(depth0,"inlineStyle") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"inlineStyle","hash":{},"data":data,"loc":{"start":{"line":11,"column":91},"end":{"line":11,"column":106}}}) : helper)))
    + "\"/>\r\n              </a>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <img class=\"intro-image\" loading=\"lazy\" src=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"src") || (depth0 != null ? lookupProperty(depth0,"src") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"src","hash":{},"data":data,"loc":{"start":{"line":14,"column":59},"end":{"line":14,"column":66}}}) : helper)))
    + "\" alt=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"alt") || (depth0 != null ? lookupProperty(depth0,"alt") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"alt","hash":{},"data":data,"loc":{"start":{"line":14,"column":73},"end":{"line":14,"column":80}}}) : helper)))
    + "\" style=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"inlineStyle") || (depth0 != null ? lookupProperty(depth0,"inlineStyle") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"inlineStyle","hash":{},"data":data,"loc":{"start":{"line":14,"column":89},"end":{"line":14,"column":104}}}) : helper)))
    + "\"/>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul class=\"list-left\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"each","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":31,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":27,"column":16},"end":{"line":27,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":16},"end":{"line":28,"column":88}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":16},"end":{"line":29,"column":66}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":27,"column":32},"end":{"line":27,"column":46}}}) : helper))) != null ? stack1 : "");
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":28,"column":33},"end":{"line":28,"column":81}}})) != null ? stack1 : "");
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":29,"column":38},"end":{"line":29,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"20":function(container,depth0,helpers,partials,data) {
    return "column small-7";
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":12},"end":{"line":44,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":14},"end":{"line":40,"column":51}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":41,"column":14},"end":{"line":41,"column":86}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":14},"end":{"line":42,"column":64}}})) != null ? stack1 : "")
    + "\r\n            </li>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"three-items\">\r\n          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"each","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":51,"column":12},"end":{"line":56,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </div>\r\n";
},"26":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":53,"column":16},"end":{"line":53,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":54,"column":16},"end":{"line":54,"column":88}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"28":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"with","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":22},"end":{"line":75,"column":13}}})) != null ? stack1 : "");
},"29":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n        <div class=\"lower-tile\">\r\n          <div class=\"lower-tile-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":67,"column":43},"end":{"line":67,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"lower-tile-icon\">\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"svg") : depth0),{"name":"if","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":12},"end":{"line":69,"column":41}}})) != null ? stack1 : "")
    + "\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":70,"column":12},"end":{"line":70,"column":89}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"cta") : depth0),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":10},"end":{"line":72,"column":72}}})) != null ? stack1 : "")
    + "\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":73,"column":10},"end":{"line":73,"column":117}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n    ";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"svg") || (depth0 != null ? lookupProperty(depth0,"svg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"svg","hash":{},"data":data,"loc":{"start":{"line":69,"column":24},"end":{"line":69,"column":33}}}) : helper))) != null ? stack1 : "")
    + " ";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
    + " loading=\"lazy\" alt="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"alt") : stack1), depth0))
    + ">";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"cta") || (depth0 != null ? lookupProperty(depth0,"cta") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cta","hash":{},"data":data,"loc":{"start":{"line":72,"column":50},"end":{"line":72,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":73,"column":56},"end":{"line":73,"column":104}}})) != null ? stack1 : "")
    + "</div>";
},"38":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row\">\r\n        <div class=\"small-12 bottom-link bottom-link--left\">\r\n            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":83,"column":12},"end":{"line":83,"column":26}}}) : helper))) != null ? stack1 : "")
    + "\r\n        </div>\r\n    </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-5\">\r\n  <div class=\"column small-9\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"menuItems") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":61,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"column small-3\">\r\n    <div class=\"offer-container\"></div>\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":65,"column":4},"end":{"line":75,"column":20}}})) != null ? stack1 : "")
    + "\r\n\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":0},"end":{"line":86,"column":9}}})) != null ? stack1 : "")
    + "\r\n";
},"useData":true});
const renderTemplate$1 = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template$1(data, options);
};

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"row collapse menu-item\">\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":5,"column":18},"end":{"line":5,"column":124}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"intro") : depth0),{"name":"with","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":8},"end":{"line":35,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n      <div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.program(29, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":37,"column":18},"end":{"line":37,"column":124}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"secondSection") : depth0),{"name":"with","hash":{},"fn":container.program(31, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":75,"column":17}}})) != null ? stack1 : "")
    + "      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"if","hash":{},"fn":container.program(36, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":77,"column":6},"end":{"line":88,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "three-items";
},"4":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "column "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"firstColumnWider") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(7, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":5,"column":61},"end":{"line":5,"column":117}}})) != null ? stack1 : "");
},"5":function(container,depth0,helpers,partials,data) {
    return "small-7";
},"7":function(container,depth0,helpers,partials,data) {
    return "small-5";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"intro\">\r\n          <h2 class=\"intro-headline "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lessMarginHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":36},"end":{"line":8,"column":89}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"smallerFontHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":89},"end":{"line":8,"column":145}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":8,"column":147},"end":{"line":8,"column":161}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":11,"column":10},"end":{"line":11,"column":90}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":8},"end":{"line":23,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":8},"end":{"line":34,"column":15}}})) != null ? stack1 : "");
},"10":function(container,depth0,helpers,partials,data) {
    return "less-margin-headline";
},"12":function(container,depth0,helpers,partials,data) {
    return " smaller-font-headline";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"intro-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":11,"column":60},"end":{"line":11,"column":77}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul class=\"list-left\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"introLinks") : depth0),{"name":"each","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":12},"end":{"line":21,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":16},"end":{"line":17,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":16},"end":{"line":18,"column":88}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":16},"end":{"line":19,"column":66}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":17,"column":32},"end":{"line":17,"column":46}}}) : helper))) != null ? stack1 : "");
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":18,"column":33},"end":{"line":18,"column":81}}})) != null ? stack1 : "");
},"22":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":19,"column":38},"end":{"line":19,"column":55}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <ul class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"removeUlLeftMargin") : depth0),{"name":"if","hash":{},"fn":container.program(25, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":21},"end":{"line":25,"column":68}}})) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"each","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":26,"column":12},"end":{"line":32,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n";
},"25":function(container,depth0,helpers,partials,data) {
    return "no-left-margin";
},"27":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":14},"end":{"line":28,"column":51}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":14},"end":{"line":29,"column":86}}})) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":30,"column":14},"end":{"line":30,"column":64}}})) != null ? stack1 : "")
    + "\r\n            </li>\r\n";
},"29":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "column "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"firstColumnWider") : depths[1]),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.program(5, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":37,"column":61},"end":{"line":37,"column":117}}})) != null ? stack1 : "");
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"second-section\">\r\n          <h2 class=\"second-section-headline "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lessMarginHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":45},"end":{"line":40,"column":98}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"smallerFontHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":40,"column":98},"end":{"line":40,"column":154}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":40,"column":156},"end":{"line":40,"column":170}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":43,"column":10},"end":{"line":43,"column":95}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":8},"end":{"line":55,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"secondSectionRow2") : depth0),{"name":"with","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":56,"column":8},"end":{"line":74,"column":17}}})) != null ? stack1 : "");
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"second-section-description\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"description") || (depth0 != null ? lookupProperty(depth0,"description") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"description","hash":{},"data":data,"loc":{"start":{"line":43,"column":67},"end":{"line":43,"column":84}}}) : helper))) != null ? stack1 : "")
    + "</p>";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"second-section second-section-row-2\">\r\n          <h2 class=\"second-section-headline "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lessMarginHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":45},"end":{"line":58,"column":98}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"smallerFontHeadline") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":58,"column":98},"end":{"line":58,"column":154}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":58,"column":156},"end":{"line":58,"column":170}}}) : helper))) != null ? stack1 : "")
    + "</h2>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"description") : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":61,"column":10},"end":{"line":61,"column":95}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"listItems") : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":63,"column":8},"end":{"line":73,"column":15}}})) != null ? stack1 : "");
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"three-items\">\r\n          <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"thirdItem") : depth0),{"name":"each","hash":{},"fn":container.program(37, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":80,"column":12},"end":{"line":85,"column":21}}})) != null ? stack1 : "")
    + "          </ul>\r\n        </div>\r\n";
},"37":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "              <li>\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":16},"end":{"line":82,"column":53}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":83,"column":16},"end":{"line":83,"column":88}}})) != null ? stack1 : "")
    + "\r\n              </li>\r\n";
},"39":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"with","hash":{},"fn":container.program(40, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":94,"column":22},"end":{"line":104,"column":13}}})) != null ? stack1 : "");
},"40":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n        <div class=\"lower-tile\">\r\n          <div class=\"lower-tile-headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":96,"column":43},"end":{"line":96,"column":57}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n          <div class=\"lower-tile-icon\">\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"svg") : depth0),{"name":"if","hash":{},"fn":container.program(41, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":98,"column":12},"end":{"line":98,"column":41}}})) != null ? stack1 : "")
    + "\r\n            "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"if","hash":{},"fn":container.program(43, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":99,"column":12},"end":{"line":99,"column":89}}})) != null ? stack1 : "")
    + "\r\n          </div>\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"cta") : depth0),{"name":"if","hash":{},"fn":container.program(45, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":101,"column":10},"end":{"line":101,"column":72}}})) != null ? stack1 : "")
    + "\r\n          "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),{"name":"if","hash":{},"fn":container.program(47, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":102,"column":10},"end":{"line":102,"column":117}}})) != null ? stack1 : "")
    + "\r\n        </div>\r\n    ";
},"41":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"svg") || (depth0 != null ? lookupProperty(depth0,"svg") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"svg","hash":{},"data":data,"loc":{"start":{"line":98,"column":24},"end":{"line":98,"column":33}}}) : helper))) != null ? stack1 : "")
    + " ";
},"43":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<img src="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"content") : stack1), depth0))
    + " loading=\"lazy\" alt="
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"icon") : depth0)) != null ? lookupProperty(stack1,"alt") : stack1), depth0))
    + ">";
},"45":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"cta") || (depth0 != null ? lookupProperty(depth0,"cta") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cta","hash":{},"data":data,"loc":{"start":{"line":101,"column":50},"end":{"line":101,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</div>";
},"47":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"lower-tile-link\">"
    + ((stack1 = (lookupProperty(helpers,"secureLink")||(depth0 && lookupProperty(depth0,"secureLink"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"secureCta") : depth0),((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"site"))) && lookupProperty(stack1,"secureHost")),{"name":"secureLink","hash":{},"data":data,"loc":{"start":{"line":102,"column":56},"end":{"line":102,"column":104}}})) != null ? stack1 : "")
    + "</div>";
},"49":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headline-left") : depth0),{"name":"if","hash":{},"fn":container.program(50, data, 0, blockParams, depths),"inverse":container.program(55, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":110,"column":0},"end":{"line":121,"column":7}}})) != null ? stack1 : "");
},"50":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row bottom-link\">\r\n  <div class=\"column small-9\">\r\n    <div class=\"row collapse bottom-link--left\">\r\n      <div class=\"column "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depths[1] != null ? lookupProperty(depths[1],"firstColumnWider") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.program(51, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":114,"column":25},"end":{"line":114,"column":81}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline-left") || (depth0 != null ? lookupProperty(depth0,"headline-left") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline-left","hash":{},"data":data,"loc":{"start":{"line":114,"column":83},"end":{"line":114,"column":102}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n      <div class=\"column "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depths[1] != null ? lookupProperty(depths[1],"firstColumnWider") : depths[1]),{"name":"if","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.program(53, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":115,"column":25},"end":{"line":115,"column":96}}})) != null ? stack1 : "")
    + " headline\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":115,"column":107},"end":{"line":115,"column":121}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";
},"51":function(container,depth0,helpers,partials,data) {
    return "small-4";
},"53":function(container,depth0,helpers,partials,data) {
    return "small-7 small-offset-1";
},"55":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"bottom-link\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":120,"column":25},"end":{"line":120,"column":39}}}) : helper))) != null ? stack1 : "")
    + "</div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row template template-6\">\r\n  <div class=\"column small-9\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"menuItems") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":90,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n  <div class=\"column small-3\">\r\n    <div class=\"offer-container\"></div>\r\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"lowerTile") : depth0),{"name":"if","hash":{},"fn":container.program(39, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":94,"column":4},"end":{"line":104,"column":20}}})) != null ? stack1 : "")
    + "\r\n\r\n  </div>\r\n</div>\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(alias1,(depth0 != null ? lookupProperty(depth0,"bottomLink") : depth0),{"name":"with","hash":{},"fn":container.program(49, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":109,"column":0},"end":{"line":122,"column":9}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  options = options || {};options.helpers = options.helpers || {};options.partials = options.partials || {};
  options.helpers = {...options.helpers, ..._moduleConfig.helpers };
  options.partials = {...options.partials, ..._moduleConfig.partials };
  return Template(data, options);
};

const checkMobileHidden = className => className && className.includes('show-for-large-up');

/**
 * @method templateName
 * @param {String} id id
 * @param {Object} menus menus
 * @returns {string} template name
 */
function templateName(id, menus) {
  return menus[id] ? menus[id].template : 'template-1';
}
/**
 * @method templateContent
 * @param {String} id id
 * @param {Object} menus menus
 * @returns {string} template content
 */
function templateContent(id, menus) {
  return menus[id] || '';
}

/**
 * @method getMobileNavRowCount
 * @param {Object} nav nav
 * @returns {Number} nav row count
 */
function getMobileNavRowCount(nav) {
  const itemsCount = nav.filter(item => !checkMobileHidden(item.class)).length;
  return Math.floor(itemsCount / 2);
}

/**
 * @method resortNavForMobile
 * @param {Object} nav nav
 * @returns {Object} newNav
 */
function resortNavForMobile(nav) {
  return nav.reduce((newNav, item, index) => {
    const isHiddenOnMobile = checkMobileHidden(item.class);
    if (isHiddenOnMobile) return newNav;
    newNav[index % nav.length] = item; // eslint-disable-line no-param-reassign

    return newNav;
  }, []);
}

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.homepage.modules/navigation-module",
  "version": "2.4.1",
  "id": "navigationModule",
  "containerID": "homepageNavigationModule",
  "moduleName": "homepage-navigation-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "navigation-module",
  "data": {
    "init": "navigationModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "customerType",
    "type": "string",
    "values": ["smallbusiness", "consumer"],
    "default": "consumer",
    "description": "need to set this so it can be referenced in hbs to determine how to create the defaultContent object"
  }, {
    "name": "adContainers",
    "type": "object",
    "values": [],
    "default": {},
    "description": "Map identifying ad containers for offers."
  }, {
    "name": "timeout",
    "type": "string",
    "values": [],
    "default": "500",
    "description": "Time (in ms) to wait for targeted content response"
  }, {
    "name": "viewport",
    "type": "string",
    "values": ["desktop", "mobile"],
    "default": "desktop",
    "description": "The viewport type module should render for."
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate$7(context, {
      "helpers": {
        templateName,
        templateContent,
        getMobileNavRowCount,
        resortNavForMobile,
        codeFriendly,
        attrFriendly,
        picture,
        secureLink,
        compare,
        json
      },
      "partials": {
        "offer": renderTemplate$6,
        "template-1": renderTemplate$5,
        "template-3": renderTemplate$4,
        "template-2": renderTemplate$3,
        "template-4": renderTemplate$2,
        "template-5": renderTemplate$1,
        "template-6": renderTemplate
      }
    });
  },
  "template": renderTemplate$7,
  "partials": {
    "offer": renderTemplate$6,
    "template-1": renderTemplate$5,
    "template-3": renderTemplate$4,
    "template-2": renderTemplate$3,
    "template-4": renderTemplate$2,
    "template-5": renderTemplate$1,
    "template-6": renderTemplate
  },
  "helpers": {
    templateName,
    templateContent,
    getMobileNavRowCount,
    resortNavForMobile,
    codeFriendly,
    attrFriendly,
    picture,
    secureLink,
    compare,
    json
  },
  "dependencies": {
    "@sparta.sales.utilities/benchmark-utility": "^1.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.homepage.helpers/homepage-helper": "^1.0.0",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.helpers/secure-link-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/picturefill": "^3.0.0",
    "@sparta.homepage.utilities/animation-utility": "^1.0.5",
    "@sparta.homepage.utilities/modal-utility": "^1.0.0",
    "@sparta.homepage.utilities/remote-logging-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0"
  },
  "stores": []
};

/* eslint-disable no-console, class-methods-use-this */

const containerType = 'navigation-offer';
let isBmhOfferServed = false;

/**
 * object to map the keys that correspond to the navSection to the
 * generic key that passed in through page config
 */
const customerTypeNavLinks = {
  consumer: {
    navAd1: 'navChecking',
    navAd2: 'navSavings',
    navAd3: 'navCreditCards',
    navAd4: 'navHomeLoans',
    navAd5: 'navAutoLoans',
    navAd6: 'navInvesting'
  },
  smallbusiness: {
    navAd1: 'navChecking',
    navAd2: 'navSavings',
    navAd3: 'navBusinessServices',
    navAd4: 'navCreditCards',
    navAd5: 'navLending',
    navAd6: 'navInvesting',
    navAd7: 'navSBResources'
  }
};

/**
 * @exports
 * @class NavigationModuleJS
 * @extends Module
 */
class navigationModuleJS extends Module {
  /**
   * @method constructor
   * @param {Object} options options
   * @param {Object} context context
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    if (this.params.viewport === 'mobile') return;
    const {
      target
    } = this.settings;
    this.mq = window.matchMedia('(min-width: 1025px)');
    this.navLinks = target.querySelectorAll('.main-nav-links li > a');
    this.menuCloses = target.querySelectorAll('.menu-close');
    this.menuContainer = target.querySelector('.menu-content-container');
    this.menuEndEl = target.querySelector('.menu-end');
    this.adaExpandCollapseSelector = '.ada-expand-collapse';
    this.menuSections = this.menuContainer.querySelectorAll('section');
    this.menuAnimationTime = 250;
    this.defaultOffers = JSON.parse(target.querySelector('#defaultOffers').dataset.jcr);
    this.offerTemplate = _moduleConfig.partials.offer;
    this.contentLoaded = new Set();
    this.customerType = this.params.customerType;
    this.offersContainer = this.params.adContainers.default || {};
    if (spaParams.siteParams.jsTimer) {
      benchmarkUtility.init(this);
    }
  }

  /**
   * @description Initializer
   * @method init
   * @returns {void} none
   */
  init() {
    this.bmhChickenSwitch();
    if (this.params.adContainers.default) {
      const adContainers = Object.values(this.params.adContainers.default) || [];
      // add container Ids to offer containers for alloy call
      adContainers.forEach(container => {
        this.assignId(container);
      });
    }
    if (this.params.viewport === 'desktop') {
      this.initForDesktop();
    }

    // document obj is used b/c the same module is used twice on the page with different HTML
    this.mobileWrapperEl = document.querySelector('.mobile-wrapper');
    this.Events.sub('SPARTA_GLOBAL_READY/spartaBootstrapUtility', () => {
      this.mobileWrapperEl.classList.remove('hide');
    }, true);
    spartaEventsUtility.pub('NAVTABS_READY');
  }

  /**
   * @description turns off BMH module based on site parameter
   * @method bmhChickenSwitch
   * @returns {void}
   */
  bmhChickenSwitch() {
    if (spaParams.siteParams.disableBMH) {
      document.getElementById('navBetterMoneyHabits').style.display = 'none';
      document.getElementById('navBetterMoneyHabitsTablet').style.display = 'none';
      document.getElementById('navBetterMoneyHabitsMobile').style.display = 'none';
    }
  }

  /**
   * @description Initialize module js for desktop only
   * @method initForDesktop
   * @returns {void} none
   */
  initForDesktop() {
    this.bindNavLinks();
    this.bindMenuClose();
    this.bindMenuAda();
    this.bindEventSubscriptions();
  }

  /**
   * @description Bind event subscriptions so that we can load the offer when AJAX request completes
   * @method bindEventSubscriptions
   * @returns {void} none
   */
  bindEventSubscriptions() {
    // eslint-disable-next-line no-restricted-syntax
    for (const adContainer of Object.values(this.offersContainer)) {
      this.Events.sub(`target-${adContainer}`, this.loadOffers.bind(this, adContainer));
    }
  }

  /**
   * @desc assign ID to ad container to ready it for alloy content
   * @method assingId
   * @param {string} adContainer ad container
   * @returns {void}
   */
  assignId(adContainer) {
    const containerKey = this.getKeyByValue(adContainer, this.offersContainer);
    // translate the generic key passed from page params into specific key, i.e 'navChecking'
    const navLink = customerTypeNavLinks[this.customerType][containerKey];
    const menuContentId = `${navLink}Content`;
    const menuSection = this.menuContainer.querySelector(`#${menuContentId}`);
    const menuContent = menuSection.querySelector('.menu-content');
    const menuOfferContainer = menuContent.querySelector('.offer-container');
    menuOfferContainer.id = adContainer;
  }

  /**
   * @description Load offers
   * @method loadOffers
   * @todo Cache data
   * @param {String} adContainer corresponding to
   * @param {Object} event [event={ event: '' }]
   * @returns {void} none
   */
  loadOffers(adContainer, event = {
    event: ''
  }) {
    // returns generic key, i.e. 'navAd1'
    const containerKey = this.getKeyByValue(adContainer, this.offersContainer);
    // translate the generic key passed from page params into specific key, i.e 'navChecking'
    const navLink = customerTypeNavLinks[this.customerType][containerKey];
    const menuContentId = `${navLink}Content`;
    const menuSection = this.menuContainer.querySelector(`#${menuContentId}`);
    const menuContent = menuSection.querySelector('.menu-content');
    const menuOfferContainer = menuContent.querySelector('.offer-container');
    const defaultOffer = this.defaultOffers[containerKey];
    const usingDefaultContent = !event.data;
    let offer;

    // validate META info
    if (event.data && event.data.META && event.data.META.CONTAINER_TYPE) {
      if (event.data.META.CONTAINER_TYPE.toLowerCase() === containerType && navigationModuleJS.isValidJson(event.data)) {
        offer = event.data;
      } else {
        offer = defaultOffer;
        remoteConsole.error(`Targeting Error: Wrong container type: ${event.data.META.CONTAINER_TYPE}. "${containerType}" expected.`);
      }
    } else {
      offer = defaultOffer;
      remoteConsole.error('Targeting Error: missing Meta information');
    }
    if (offer) {
      navigationModuleJS.renderContent(menuOfferContainer, this.offerTemplate(offer));
      modalUtility.init(offer);
      if (usingDefaultContent) {
        menuOfferContainer.setAttribute('data-default-content', adContainer);
      } else {
        menuOfferContainer.setAttribute('data-ad-container', adContainer);
        if (offer.clickToken) {
          menuOfferContainer.setAttribute('data-ad-click-token', offer.clickToken);
        }
      }

      // if IE manually call picturefill method
      if (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
        setTimeout(() => picturefill(), 1500);
      }
      this.contentLoaded.add(adContainer);
      if (offer.animations) {
        animationUtility.init(menuOfferContainer, offer.animations);
      }
    }
  }

  /**
   * @description returns the navLink Key that is associated with the adContainer
   * coming from the moduleParams
   * @method getKeyByValue
   * @param {String} value value to get key from
   * @param {Object} object object containg key/values to look through
   * @returns {string} generic key associated with the adContainer
   */
  getKeyByValue(value, object) {
    return Object.keys(object).find(key => object[key] === value);
  }

  /**
   * @description Bind the menu's ADA
   * @method bindMenuAda
   * @memberof navigationModuleJS
   * @returns {void}
   */
  bindMenuAda() {
    // The focus element we listen for
    const menuEnd = this.menuContainer.querySelector('.menu-end');
    menuEnd.addEventListener('focus', () => {
      if (this.currentMenuSection) {
        this.currentMenuSection.querySelector('.menu-close').focus();
      }
    });
  }

  /**
   * @description Bind main navigation links.
   * @method bindNavLinks
   * @returns {void} none
   */
  bindNavLinks() {
    Array.from(this.navLinks).forEach(navLink => {
      navLink.addEventListener('click', this.navLinkHandler.bind(this));
    });
  }

  /**
   * @description Bind menu close icons.
   * @method bindMenuClose
   * @returns {void} none
   */
  bindMenuClose() {
    Array.from(this.menuCloses).forEach(menuClose => {
      menuClose.addEventListener('click', this.closeMenu.bind(this));
    });
  }

  /**
   * @description Close menu event.
   * @method closeMenu
   * @return {void} none
   */
  closeMenu() {
    this.closeMenuItems();
    this.removeSelectedNavLinks();
    this.menuContainer.classList.remove('active');
    if (this.currentNavElement) {
      // Instead of having a bunch of event listeners for animationend this should suffice.
      setTimeout(() => {
        this.currentNavElement.focus();
      }, this.menuAnimationTime);
    }
  }

  /**
   * @description Close menu items event.
   * @method closeMenuItems
   * @returns {void} none
   */
  closeMenuItems() {
    Array.from(this.menuSections).forEach(menuSection => {
      menuSection.classList.remove('active');
    });
  }

  /**
   * @description Remove selected class from navigation link.
   * Instead of using a class, use aria-selected attr.
   * @method removeSelectedNavLinks
   * @returns {none} none
   */
  removeSelectedNavLinks() {
    Array.from(this.navLinks).forEach(linkWrapper => {
      linkWrapper.removeAttribute('aria-selected');
    });
  }

  /**
   * @description VTIM requested that this container be added to the DOM upon menu click
   * @return {void}
   */
  addBmhContainer() {
    if (isBmhOfferServed) return;
    const bmhContent = this.settings.target.querySelector('.bmh-offer-container');
    navigationModuleJS.renderContent(bmhContent, this.offerTemplate(JSON.parse(bmhContent.dataset.jcr)));
    isBmhOfferServed = true;
  }

  /**
   * @description Handler for the nav link event.
   * @method navLinkHandler
   * @param {Event} event event
   * @returns {void}
   */
  navLinkHandler(event) {
    if (!this.mq.matches) return;
    const currentElement = event.currentTarget;
    const currentSelected = currentElement.hasAttribute('aria-selected');
    const menuContentId = `${currentElement.id}Content`;
    const menuSection = this.menuContainer.querySelector(`#${menuContentId}`);
    this.closeMenu();

    // Nav link already open, stop, leave as closed state.
    if (currentSelected) {
      currentElement.setAttribute('aria-expanded', false);
      this.menuEndEl.setAttribute('tabindex', -1);
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    currentElement.setAttribute('aria-selected', 'true');
    currentElement.setAttribute('aria-expanded', true);
    this.menuEndEl.setAttribute('tabindex', 0);
    try {
      this.menuContainer.classList.add('active');
      menuSection.classList.add('active');
      event.preventDefault();
      event.stopPropagation();
      this.currentMenuSection = menuSection;

      // Instead of having a bunch of event listeners for animationend this should suffice.
      setTimeout(() => {
        // Store cta that was clicked to focus back to when closing.
        this.currentNavElement = currentElement;
        menuSection.querySelector('.menu-close').focus();

        // if (currentElement.id === BMH_MENU_ID && currentElement.getAttribute('aria-expanded') === 'true') {
        //   this.addBmhContainer();
        // }
      }, this.menuAnimationTime);
    } catch (e) {
      console.error(e); // eslint-disable-line no-console
    }
  }

  /**
   * @description Validates JSON object for XSS
   * @method isValidJson
   * @param {object} jsonObj data for template
   * @returns {boolean} true/false
   */
  static isValidJson(jsonObj) {
    try {
      const content = JSON.stringify(jsonObj);
      const scriptExp = /(?:<[^>]+\s)(on\S+)(\s+)?=(\s+)?["']?/ig;
      const scriptTag = /<[^>]*script|(?:<[^>]+\s)(on\S+)(\s+)?=(\s+)?["']?/ig;
      const iFrameTag = /<[^>]*iframe/ig;
      if (content.match(scriptExp) || content.match(scriptTag) || content.match(iFrameTag)) {
        return false;
      }
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  /**
   * @description Renders content in element
   * @method renderContent
   * @param {HTMLElement} elem elem
   * @param {string} content content
   * @returns {void}
   */
  static renderContent(elem, content) {
    // eslint-disable-next-line no-param-reassign
    elem.innerHTML = content;
  }
}
registerModuleClass({
  moduleClass: navigationModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { navigationModuleJS as default, moduleConfig };
